var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-dropdown',_vm._g(_vm._b({},'n-dropdown',_vm.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }